import React from "react";

export interface ErrorProps {}

const Error: React.FC<ErrorProps> = ({ children }) => {
	return <small className="error">{children}</small>;
};

export default Error;
